import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { appActions } from '../../actions/app_actions.js';
import { actionTanks } from '../../actions/tanks_actions.jsx';
import Loader from '../controls/loader/loader.jsx';
import { authenticationService } from '../../services/authenticationService.js';
import { Route, Redirect } from 'react-router-dom';

class Startup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    //componentDidMount() {
    //    const currentUser = authenticationService.currentUserValue;
    //    if (currentUser && !this.props.ready && !this.props.isLoading) {
    //        this.props.actions.getAppSettings();
    //    } else {
    //        //this.props.history.push('/login');
    //    };
    //}

    static getDerivedStateFromProps(props, state) {
        const currentUser = authenticationService.currentUserValue;
        if (currentUser && !props.ready && !props.loading) {
            props.actions.getAppSettings();
            props.actions.getAreas();
        } else {
            //props.history.push('/login');
        };
        return state;
    }

    render() {
        const currentUser = authenticationService.currentUserValue;
        return this.props.ready || !currentUser ? this.props.children : <Loader />;
    }
}

function mapStateToProps(state) {
    return {
        ready: state.app.ready,
        loading: state.app.loading
    }
}

function mapDispatchToProps(dispath) {
    return {
        actions: bindActionCreators({ ...appActions, ...actionTanks }, dispath)
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Startup);